import USER_API from 'api/user/v1'
import { call, put, takeLatest } from 'redux-saga/effects'
import { notificationShow } from 'modules/Notifications/actions'

function* getAccounts() {
  return yield call(USER_API.fetchAll)
}

function* deleteAccount() {
  return yield call(USER_API.deleteAdmitadAccount)
}

function* getUserAccountsConnected() {
  try {
    yield put({
      type: 'USER/ACCOUNTS_CONNECTED_FETCH_START',
      payload: 'user/accounts',
    })
    const { response, error } = yield call(getAccounts)

    if (error) {
      throw error
    }

    yield put({
      type: 'USER/SET_ACCOUNTS_CONNECTED',
      payload: response.data,
    })
  } catch (error) {
    yield put({
      type: 'USER/ACCOUNTS_CONNECTED_FETCH_FAIL',
      payload: 'user/accounts',
    })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  } finally {
    yield put({
      type: 'USER/ACCOUNTS_CONNECTED_FETCH_END',
      payload: 'user/accounts',
    })
  }
}

function* deleteUserAccount() {
  try {
    yield put({
      type: 'USER/DELETE_ACCOUNT_FETCH_START',
      payload: 'user/accounts',
    })
    const { error } = yield call(deleteAccount)

    if (error) {
      throw error
    }

    yield put({
      type: 'USER/SET_ACCOUNTS_CONNECTED',
      payload: {},
    })
  } catch (error) {
    yield put({
      type: 'USER/DELETE_ACCOUNT_FETCH_FAIL',
      payload: 'user/accounts',
    })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  } finally {
    yield put({
      type: 'USER/DELETE_ACCOUNT_FETCH_END',
      payload: 'user/accounts',
    })
  }
}

export default function* Sagas() {
  yield takeLatest('USER/GET_USER_ACCOUNTS_CONNECTED', getUserAccountsConnected)
  yield takeLatest('USER/DELETE_USER_ACCOUNT', deleteUserAccount)
}
